import { tv } from '@/common/theme/tv.config';

export const styles = {
  content: tv({
    base: 'z-10 cursor-pointer rounded-md bg-neutral10 shadow-resting-neutral10 web:overflow-hidden',
  }),
  viewport:
    'h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]',
  group: 'max-h-[25.4rem]',
  item: 'p-md focus:outline-none focus:ring-0 focus:border-0 focus:bg-neutral20 hover:bg-neutral20 w-full',
  itemIndicator: 'w-md',
  footer: 'border-t border-neutral20 p-md',
};
